import { useTheme } from '@mui/material/styles';
import { Link } from '@mui/material';
import DrawerHeaderStyled from './DrawerHeaderStyled';
import useDefaultPath from 'hooks/useDefaultPath';
import { Link as RouterLink } from 'react-router-dom';
import useOrganization from 'hooks/useOrganization';

import DefaultLogo from 'assets/images/logo.svg';
import DefaultLogo02 from 'assets/images/logo02.svg';

import PublicSoftLogo from 'assets/images/partners/publicsoft.png';
import PublicSoftLogo02 from 'assets/images/partners/publicsoft02.png';

interface Props {
  open: boolean;
}

const DrawerHeader = ({ open }: Props) => {
  const theme = useTheme();
  const { organization } = useOrganization();
  const defaultPath = useDefaultPath();

  const isPublicSoft = organization?.owner_name === 'PublicSoft';

  const fullLogo = isPublicSoft ? PublicSoftLogo : DefaultLogo;
  const iconLogo = isPublicSoft ? PublicSoftLogo02 : DefaultLogo02;
  const logoAlt = isPublicSoft ? 'PublicSoft' : '0Paper';

  const logoWidth = isPublicSoft ? 210 : 230;
  const logoHeight = isPublicSoft ? 45 : 70;

  return (
    <DrawerHeaderStyled
      theme={theme}
      open={open}
      sx={{
        minHeight: '60px',
        width: 'inherit',
        paddingTop: open ? '24px' : '16px',
        paddingBottom: open ? '8px' : 0,
        paddingLeft: open ? '24px' : 0
      }}
    >
      {open && (
        <Link variant="h1" component={RouterLink} to={defaultPath} color="text.primary" underline="none">
          <img src={fullLogo} alt={logoAlt} width={logoWidth} height={logoHeight} />
        </Link>
      )}

      {!open && (
        <Link variant="h1" component={RouterLink} to={defaultPath} color="text.primary" underline="none">
          <img src={iconLogo} alt={logoAlt} width="40" height="40" />
        </Link>
      )}
    </DrawerHeaderStyled>
  );
};

export default DrawerHeader;
